import { Component, OnInit } from '@angular/core';
import { SharedDataService } from 'ngx-paf-common';

@Component({
  selector: 'non-admin-lock-panel',
  templateUrl: './non-admin-lock-panel.component.html',
  styleUrls: ['./non-admin-lock-panel.component.scss']
})
export class NonAdminLockPanelComponent implements OnInit {

  constructor(public sharedDataSvc:SharedDataService) { }

  ngOnInit(): void {
  }
}
